export var RepeatMonthlyStrategy;
(function (RepeatMonthlyStrategy) {
    RepeatMonthlyStrategy["OnDay"] = "ON_DAY";
    RepeatMonthlyStrategy["OnFirstWeekday"] = "FIRST";
    RepeatMonthlyStrategy["OnSecondWeekday"] = "SECOND";
    RepeatMonthlyStrategy["OnThirdWeekday"] = "THIRD";
    RepeatMonthlyStrategy["OnFourthWeekday"] = "FOURTH";
    RepeatMonthlyStrategy["OnLastWeekday"] = "LAST";
})(RepeatMonthlyStrategy || (RepeatMonthlyStrategy = {}));
